import { AcceptType } from '@components/file-field/types';
import { InstantUploadFileFieldProps } from '@components/instant-upload-file-field';
import {
  BaseFieldMappingFieldProps,
  FieldMappingData,
} from '@components/text-editors/addons/field-mapping';
import { SingleField } from '@components/text-editors/addons/single-field';

import { FieldMappingFileListField } from './field-mapping-file-list-field';

export type FieldMappingFileFieldProps = BaseFieldMappingFieldProps &
  FieldMappingData &
  Partial<Pick<InstantUploadFileFieldProps, 'onSelect' | keyof AcceptType>> & {
    allowUploadFiles?: boolean;
  };

export const FieldMappingFileField = ({
  defaultValue,
  onChange,
  ...rest
}: FieldMappingFileFieldProps) => (
  <FieldMappingFileListField
    extensions={[SingleField]}
    defaultValue={defaultValue ? [defaultValue] : undefined}
    onChange={(value) => onChange?.(value[0])}
    {...rest}
  />
);
